import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./styles.scss";

import { baseURL } from "../../../../misc/http";
import { Link } from "react-router-dom";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const CustomDot = ({ onClick, ...rest }) => {
  const {
    onMove,
    index,
    active,
    carouselState: { currentSlide, deviceType },
  } = rest;
  // const carouselItems = [1, 2, 3];
  // onMove means if dragging or swiping in progress.
  // active is provided by this lib for checking if the item is active or not.
  return (
    <div
      className={active ? "active" : "inactive"}
      style={{
        width: 24,
        height: 4,
        borderRadius: 19,
        backgroundColor: active ? "#1672BD" : "#DADADA",
        margin: 5,
        cursor: "pointer",
      }}
      onClick={() => onClick()}
    >
      {React.Children.toArray()[index]}
    </div>
  );
};

export default function CarouselWrapper({ data }) {
  return (
    <div style={{ width: "100%" }}>
      <Carousel
        swipeable={false}
        draggable={false}
        showDots={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        dotListClass="dot-list-style"
        arrows={false}
        renderDotsOutside={true}
        customDot={<CustomDot />}
      >
        {data.map((item, idx) => {
          return (
            <a key={idx} href={item.link}>
              <img
                src={`${baseURL + item.image}`}
                alt={`slide${idx}`}
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                  // height: "50px",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: 'flex',
                  padding: 20,
                  justifyContent: !item.title ? 'flex-end' : 'space-between',
                  alignItems: 'center',
                  borderRadius: 5,
                }}
              >
                {item.title && (
                  <p style={{ margin: 0, color: "white" }} className="p-nunito">
                    {item.title}
                  </p>
                )}
                <div style={{backgroundColor: '#1672BD', borderRadius: 20}}>
                  <p style={{ margin: 0, color: "white", padding: '5px 15px' }} className="p-nunito">{item.buttonCaption}</p>
                </div>
              </div>
            </a>
          );
        })}
      </Carousel>
    </div>
  );
}
